import React, {useState, useEffect, useCallback} from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import {CopyToClipboard as ReactCopyToClipboard} from 'react-copy-to-clipboard'

const TIMEOUT = 1500

const CopyToClipboard = ({text, children, className}) => {
  const [copySuccess, setCopySuccess] = useState(false)

  useEffect(() => {
    if (!copySuccess) return

    const timeoutId = setTimeout(() => setCopySuccess(false), TIMEOUT)
    return () => clearTimeout(timeoutId)
  }, [copySuccess])

  const onCopyHandler = useCallback(
    (text, result) => setCopySuccess(!!result),
    []
  )

  return (
    <ReactCopyToClipboard text={text} onCopy={onCopyHandler}>
      <div
        className={classNames('tooltip-is-mobile', className)}
        data-tooltip={copySuccess ? 'Copied' : null}>
        {children}
      </div>
    </ReactCopyToClipboard>
  )
}

CopyToClipboard.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  text: PropTypes.string.isRequired,
}

export default CopyToClipboard
